import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AccountComponent } from './account.component';
import { NewAccountRoutingModule } from './account.routing';

import { NavigationModule } from '../shared/navigation/navigation.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    NavigationModule,
    NewAccountRoutingModule
  ],
  declarations: [AccountComponent],
  providers: []
})
export class NewAccountModule {}
